import { render, staticRenderFns } from "./selected_area.vue?vue&type=template&id=2a6e6354&"
import script from "./selected_area.vue?vue&type=script&lang=js&"
export * from "./selected_area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports